import { AxiosResponse } from "axios";
import { Observable } from "rxjs";

export const axiosToObservable = <T>(axiosPromise: Promise<AxiosResponse<T>>): Observable<T> => {
    return new Observable<T>((observer) => {
      axiosPromise
        .then((response) => {
          observer.next(response.data);
          observer.complete();
        })
        .catch((error) => {
          observer.error(error);
        });
    });
  };